// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5":"1bc3ddb9","92":"1bc3ddb9","477":"1bc3ddb9","570":"2ef81caf"}[chunkId] + ".chunk.css";
};